"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * 向指定url中添加参数
 * @type {function}
 * @param {string} url                      - 指定url链接
 * @param {string} key                      - 参数的键
 * @param {string} value                    - 参数的值
 * @return {string}
 */
var setParamToURL = function (url, key, val) {
    try {
        if (typeof url !== 'undefined' && typeof key !== 'undefined' && typeof val !== 'undefined') {
            // 将 http 替换 https
            if (url.indexOf('http://') > -1) {
                url = url.replace('http://', 'https://');
            }
            // 如果存在hash
            if (url.indexOf('#') > -1) {
                var tmpArr = url.split('#');
                url = setParamToURL(tmpArr[0], key, val) + '#' + tmpArr[1];
                // 纯url处理
            }
            else {
                val = encodeURIComponent(val);
                if (url.indexOf('?') === -1) {
                    url += '?' + key + '=' + val;
                }
                else {
                    var urlParamArr = url.split('?');
                    var pStr = urlParamArr[1];
                    var pArr_1 = pStr.split('&');
                    var findFlag_1 = false;
                    pArr_1.every(function (item, index) {
                        var paramArr = item.split('=');
                        if (key === paramArr[0]) {
                            findFlag_1 = true;
                            pArr_1[index] = key + '=' + val;
                            return false;
                        }
                        else {
                            return true;
                        }
                    });
                    if (!findFlag_1) {
                        url += '&' + key + '=' + val;
                    }
                    else {
                        url = urlParamArr[0] + '?' + pArr_1.join('&');
                    }
                }
            }
        }
    }
    catch (e) {
        typeof console !== 'undefined' && typeof console.log === 'function' && console.log(e);
    }
    return url;
};
function _getQueryParam(param1, param2) {
    var url = '';
    var param = null;
    // 如果只有一个参数，默认从当前页面链接获取参数
    if (typeof param2 === 'undefined') {
        url = window && window.location.href || '';
        param = param1;
        // 从指定url中获取参数
    }
    else {
        url = param1;
        param = param2;
    }
    url = url.split('#')[0];
    if (url.indexOf('?') > -1) {
        url = url.split('?')[1];
    }
    var reg = new RegExp('(^|&)' + param + '=([^&]*)[&#$]*', 'i');
    var rstArr = url.match(reg);
    if (rstArr !== null) {
        return decodeURIComponent(rstArr[2]);
    }
    return null;
}
/**
 * 【说明】获取url中query部分的参数并返回
 * 【使用】
 *  方式一：getQueryParam(key)      // 从当前页面连接的query中获取指定key的值
 *  方式二：getQueryParam(url, key) // 从指定url的query中获取指定key的值
 */
exports.getQueryParam = _getQueryParam;
function _setQueryParam(url, param1, param2) {
    // 只添加1个参数
    if (typeof param1 === 'string' && typeof param2 !== 'undefined') {
        url = setParamToURL(url, param1, param2);
        // 添加多个参数
    }
    else if (typeof param1 === 'object') {
        for (var i in param1) {
            url = setParamToURL(url, i, param1[i]);
        }
    }
    return url;
}
/**
 * 【说明】向url中query部分添加参数并返回处理后的链接
 * 【使用】
 *  方式一：setQueryParam(url, param)      // 向指定url中的query添加参数对象param
 *  方式二：setQueryParam(url, key, value) // 向指定url中的query，以key/value的形式添加参数
 */
exports.setQueryParam = _setQueryParam;
function _getHashParam(param1, param2) {
    var url = '';
    var param = null;
    // 如果只有一个参数，默认从当前页面链接获取参数
    if (typeof param2 === 'undefined') {
        url = window && window.location.href || '';
        param = param1;
        // 从指定url中获取参数
    }
    else {
        url = param1;
        param = param2;
    }
    var hash = url.indexOf('#') > -1 ? url.split('#')[1] : '';
    return exports.getQueryParam(hash, param);
}
/**
 * 【说明】获取url中hash部分的参数并返回
 * 【使用】
 *  方式一：getHashParam(key)      // 从当前页面连接的hash中获取指定key的值
 *  方式二：getHashParam(url, key) // 从指定url的hash中获取指定key的值
 */
exports.getHashParam = _getHashParam;
function _setHashParam(url, param1, param2) {
    var pathHashArr = url.split('#');
    var hash = url.indexOf('#') > -1 ? pathHashArr[1] : '';
    var path = pathHashArr[0];
    // 只添加1个参数
    if (typeof param1 === 'string' && typeof param2 !== 'undefined') {
        hash = setParamToURL(hash, param1, param2);
        // 添加多个参数
    }
    else if (typeof param1 === 'object') {
        for (var i in param1) {
            hash = setParamToURL(hash, i, param1[i]);
        }
    }
    return path + '#' + hash;
}
/**
 * 【说明】向url的hash部分添加参数并返回处理后的链接
 * 【使用】
 *  方式一：setHashParam(url, param)      // 向指定url中的hash添加参数对象param
 *  方式二：setHashParam(url, key, value) // 向指定url中的hash，以key/value的形式添加参数
 */
exports.setHashParam = _setHashParam;
function _getQueryObject(url) {
    var rst = {};
    if (!url) {
        url = window && window.location.href || '';
    }
    // 去掉hash
    if (url.indexOf('#') > -1) {
        url = url.split('#')[0];
    }
    // 去掉问号
    if (url.indexOf('?') > -1) {
        url = url.split('?')[1];
        for (var _i = 0, _a = url.split('&'); _i < _a.length; _i++) {
            var i = _a[_i];
            var paramArr = i.split('=');
            try {
                rst[paramArr[0]] = paramArr[1];
            }
            catch (e) {
                console.log(e);
            }
        }
    }
    return rst;
}
/**
 * 【说明】将url中query部分的参数转换为数据对象并返回
 * 【使用】
 *  方式一：setHashParam()    // 将当前页面链接中query部分的参数转换为数据对象并返回
 *  方式二：setHashParam(url) // 将url中query部分的参数转换为数据对象并返回
 */
exports.getQueryObject = _getQueryObject;
function _getHashObject(url) {
    var queryObj = {};
    if (!url) {
        url = window && window.location.hash || '';
    }
    if (url.indexOf('#') > -1) {
        url = url.split('#')[1];
    }
    var query = url.split('?')[1];
    if (query) {
        query.split('&').forEach(function (item) {
            var kvArr = item.split('=');
            if (kvArr.length === 2) {
                queryObj[kvArr[0]] = kvArr[1];
            }
        });
    }
    return queryObj;
}
/**
 * 【说明】将url中hash部分的参数转换为数据对象并返回
 * 【使用】
 *  方式一：setHashParam()    // 将当前页面链接中hash部分的参数转换为数据对象并返回
 *  方式二：setHashParam(url) // 将url中hash部分的参数转换为数据对象并返回
 */
exports.getHashObject = _getHashObject;
function _getParam(param1, param2) {
    var url = '';
    var param = null;
    // 如果只有一个参数，默认从当前页面链接获取参数
    if (typeof param2 === 'undefined') {
        url = window && window.location.href || '';
        param = param1;
        // 从指定url中获取参数
    }
    else {
        url = param1;
        param = param2;
    }
    var rst = exports.getHashParam(url, param);
    if (!rst) {
        rst = exports.getQueryParam(url, param);
    }
    return rst;
}
/**
 * 【说明】获取url中指定的参数并返回，优先从hash中取，hash没有再从query中取
 * 【使用】
 *  方式一：setHashParam()    // 将当前页面链接中hash部分的参数转换为数据对象并返回
 *  方式二：setHashParam(url) // 将url中hash部分的参数转换为数据对象并返回
 */
exports.getParam = _getParam;
